// Import Packages
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

// Import Pages
import { TextInput } from "../../../FlowConfigurationInputs/TextInput/NewTextInput";
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';

// Import Material UI
import { Checkbox, FormControl, FormControlLabel, MenuItem, Select } from "@material-ui/core";

// Import Recoil
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { saveAvailable, initialActions, changedFields } from "../../../../recoil-store/recoil-state";

// Import Helpers
import { CheckIfFlowUpdated } from '../../../../helpers/helper';

export default function Delete({ action, variables, setOpenVariable, automId }) {
  const [sizeType, setSizeType] = useState("");
  const [checked, setChecked] = useState(false);
  const initialActionsData = useRecoilValue(initialActions);
  const setSaveAvailable = useSetRecoilState(saveAvailable);
  const [changedFieldsState, setChangeFields] = useRecoilState(changedFields);
  const { t } = useTranslation();
  const label = "CONTENT.CONFIGURATION-FORM.FILE.";

  // delete  action is control default value and isRequeid area
  useEffect(() => {
    if (!action.fields.sizeType) {
      action.fields.sizeType = { value: "" };
    } else {
      if (action.fields.sizeType.value.length > 0) {
        setChecked(true);
      }
      setSizeType(action.fields.sizeType.value);
    }
    if (!action.fields.size?.value) {
      action.fields.size = { value: "" };
    }
  }, [action, variables]);

  // set selected size type
  function handleSizeTypeChange(e) {
    const field = initialActionsData[action.id]?.fields.sizeType;
    const oldValue = !field ? undefined : field.value;
    CheckIfFlowUpdated('sizeType', action, oldValue, e.target.value, setSaveAvailable, setChangeFields, changedFieldsState);

    setSizeType(e.target.value);
    action.fields.sizeType.value = e.target.value;
  }

  // select input is a change assign object value
  function handleChange(event) {
    setChecked(!checked);
    if (!event.target.checked) {
      action.fields.sizeType.value = "";
      action.fields.size.value = "";
      action.fields.size.htmlValue = "";
      action.fields.size.isRequired = false;
      const field = initialActionsData[action.id]?.fields.sizeType;
      const oldValue = !field ? undefined : field.value;
      CheckIfFlowUpdated('sizeType', action, oldValue, "", setSaveAvailable, setChangeFields, changedFieldsState);
    } else {
      action.fields.size.isRequired = true;
      setSizeType('');
    }
  }

  return (
    <div>
      <div className="conf-field-container">
        <FieldLabel name={t(label + "FILE")} is_required />
        <TextInput
          action={action}
          inputName="filePath"
          variables={variables}
          setOpenVariable={setOpenVariable}
          isRequired={true}
          extractPath="file"
          fieldType="string"
          displayName={t(label + 'FILE')}
          hideRequired
          autom_id={automId}
        />
      </div>
      <div className="conf-field-container">
        <FormControlLabel
          control={
            <Checkbox
              checked={checked}
              onChange={handleChange}
              name="size"
              color="#C4C4C4"
              size="small"
            />
          }
          label={t(label + "SIZE")}
        />

        {checked && <>
          <div className="conf-field-container">
            <FormControl variant="outlined" disabled={!checked} fullWidth style={{ width: "90%" }}>
              <Select value={sizeType} onChange={handleSizeTypeChange}>
                <MenuItem value="atleast">{t(label + "ATLEAST")}</MenuItem>
                <MenuItem value="atmost">{t(label + "ATMOST")}</MenuItem>
                <MenuItem value="exact">{t(label + "EXACT")}</MenuItem>
              </Select>
            </FormControl>
          </div>
          <div
            className="conf-field-container"
            style={{ pointerEvents: !checked && "none" }}
          >

            <FieldLabel name={`${t(label + "SIZE")}(KB)`} is_required />
            <TextInput
              action={action}
              inputName="size"
              variables={variables}
              setOpenVariable={setOpenVariable}
              isRequired={checked}
              fieldType="number"
              displayName={t(label + 'SIZE')}
              hideRequired
            />
          </div>
        </>

        }

      </div>
    </div>
  );
}